module.exports = "https://www.gc-qa.gnp.com.mx/1f7d0b702178d0127c9d3149050edccf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/loader-logo-gnp.svg
// module id = 8145
// module chunks = 0